/* @flow */

import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";

import { OverlayTrigger, Popover } from "react-bootstrap";

class NoPrice extends React.Component<{
    [x: string]: any;
}> {
    static propTypes = {
        id: PropTypes.string
    };

    getOverlay = (propId: string | undefined | null) => {
        if (propId) {
            return (
                <Popover id={"Popover" + propId}>
                    <FormattedMessage id="EX_NO_PRICE_AVAILABLE" />
                </Popover>
            );
        }
        return null;
    };

    render() {
        return (
            <OverlayTrigger
                trigger={["click", "hover"]}
                placement="bottom"
                delayHide={100}
                overlay={this.getOverlay(this.props.id)}>
                <span className="mfcss_card-article-2--price-error clickable">
                    <span className="icon-warning" />
                    <FormattedMessage id="EX_PRICE_WITHOUT_NUMBERS" />
                </span>
            </OverlayTrigger>
        );
    }
}

export default NoPrice;
